import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { MfaTotpWizard } from '../components/auth/MfaTotpWizard';

const schema = z.object({ session: z.string().min(1) });

export const Route = createFileRoute('/login/mfa-totp-setup')({
    validateSearch: (s: Record<string, unknown>) => schema.parse(s),
    component: MfaTotpSetupRoute,
});

function MfaTotpSetupRoute() {
    // El backend no soporta enrolar MFA en login; el wizard ahora es informativo.
    // AuthLayout lo provee el parent /login vía <Outlet />.
    return <MfaTotpWizard />;
}
